






































































































































































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { Search, SortDirection } from '@/data/models/search.model';
import { ServiceInstance, ServiceInstanceTotals } from '@/data/models/serviceinstance.model';
import { ServiceInstanceService } from '@/data/services/serviceinstance.service';

@Component
export default class ServizioList extends Vue {
	@Prop({ default: false }) checkboxable!: boolean;
	@Prop({ default: false }) selectable!: boolean;

	@Inject('CrudService') crudService!: CrudService<ServiceInstance>;
	@Inject('ServiceInstanceService') serviceinstanceService!: ServiceInstanceService;

	rows: ServiceInstance[] = [];
	totals!: ServiceInstanceTotals;
	loading: boolean = false;
	checkedRows: ServiceInstance[] = [];

	advancedSearch: Search = new Search('serviceinstance');

	constructor() {
		super();
		this.totals = new ServiceInstanceTotals();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	load() {
		this.checkedRows = [];

		const datareq = this.crudService.searchEntities(
			ServiceInstance,
			'serviceinstance',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			ServiceInstance,
			'serviceinstance',
			this.advancedSearch
		);
		const amountreq = this.serviceinstanceService.serviceBalance(this.advancedSearch);

		this.loading = true;
		Promise.all([datareq, countreq, amountreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
				this.totals = results[2];
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	deleteServizio(item: ServiceInstance) {
		this.$emit('delete', item);
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.load();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.load();
	}

	onCheck(checked: ServiceInstance[]) {
		this.$emit('update:selected', checked);
	}

}
